import React, { useState, useEffect } from "react";
import { Layout } from "../../../components/Layout/Layout";
import { Button } from "../../../components/Button/Button";
import { http } from "../../../utils/httpCommon";
import { TextInput } from "../../../components/TextInput/TextInput";
import CustomTextInput from "../../../components/CustomTextInput/CustomTextInput";
import { useForm } from "react-hook-form";
import useFetchData from "../../../hooks/FetchData";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import plus from "../../../assets/icons/plus.png";
import { Controller } from "react-hook-form";
import DropFile from "../../../components/DropFile/DropFile";
import { useNavigate, useParams } from "react-router-dom";
import coin from "../../../assets/coin.png";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import LoadingCircle from "../../../components/LoadingCircle/LoadingCircle";
import useFetchPostData from "../../../hooks/FetchPostData";
import { toast } from "react-hot-toast";
import AsyncSelect from "react-select/async";
import stopIcon from "../../../assets/stop.svg";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CustomTextField = styled(TextField)({
  backgroundColor: "white",
  ".MuiInputBase-input": {
    margin: " 0 10px",
    paddingLeft: "10px",
    borderLeft: "1px solid #EFEFEF",
  },
  "& .MuiFormLabel-root": {
    fontSize: "16px",
    fontWeight: "500",
  },
  "& label.Mui-focused": {
    color: "black",
    fontSize: "16px",
    fontWeight: "500",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#EFEFEF",
    },
  },
});

let weekdays = [
  { name: "Friday", value: "Friday" },
  { name: "Saturday", value: "Saturday" },
  { name: "Sunday", value: "Sunday" },
  { name: "Monday", value: "Monday" },
  { name: "Tuesday", value: "Tuesday" },
  { name: "Wednesday", value: "Wednesday" },
  { name: "Thursday", value: "Thursday" },
];

const EditLocation = () => {
  const navigator = useNavigate();
  const params = useParams();
  const {
    response: location,
    loading: facilityLoading,
    fetchData: facilityFetchData,
  } = useFetchData(`/location/${params.id}`);

  const {
    response: locationPaymentMethods,
    refetch: refetchPaymentMethods,
  } = useFetchData(
    params.id ? `/location/${params.id}/payment-methods` : null
  );

  //get all amenities
  const { response: amenities, loading } = useFetchPostData(
    "/amenity/all",
    JSON.stringify({
      page: 1,
      limit: 10000,
    })
  );

  //get all package Tiers
  const [loadingPackageTiers, setLoadingPackageTiers] = useState(false);
  const [packageTiers, setPackageTiers] = useState([]);

  const fetchPackageTiers = async () => {
    setLoadingPackageTiers(true);
    try {
      let res = await http.get("/package-tier?limit=1000000&page=1");
      setPackageTiers(res.data?.packageTiers);
      setLoadingPackageTiers(false);
    } catch (error) {
      setLoadingPackageTiers(false);
    }
  };

  useEffect(() => {
    fetchPackageTiers();
  }, []);

  const schema = yup
    .object({
      name: yup.string().required(),
      area: yup
        .number()
        .positive()
        .integer()
        .required()
        .typeError("Area is a required filed and must be positive integer"),
      netArea: yup
        .number()
        .positive()
        .typeError("Net Area is a required filed and must be positive integer")
        .integer()
        .required(),
      checkinPriceCoins: yup
        .number()
        .positive()
        .typeError("Check in price coins is a required filed and must be positive integer")
        .integer()
        .required(),
      checkinPriceCash: yup
        .number()
        .positive()
        .typeError("check in price cash is a required filed and must be positive integer")
        .integer()
        .required(),
      target: yup
        .number()
        .positive()
        .min(0)
        .typeError("Target should be a positive number")
        .integer()
        .required(),
      starts: yup.string(),
      ends: yup.string(),
      teamLeader: yup.string(),
      notes: yup.string(),
      nas: yup.string(),
      metabaseDashboardRevenueNumber: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired()
        .positive("Metabase Dashboard Revenue Number should be a positive integer")
        .typeError("Metabase Dashboard Revenue Number should be a positive integer")
        .integer("Metabase Dashboard Revenue Number should be an integer"),
      metabaseDashboardFinanceNumber: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired()
        .positive("Metabase Dashboard Finance Number should be a positive integer")
        .typeError("Metabase Dashboard Finance Number should be a positive integer")
        .integer("Metabase Dashboard Finance Number should be an integer"),
      metabaseDashboardCommunityNumber: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired()
        .positive("Metabase Dashboard Community Number should be a positive integer")
        .typeError("Metabase Dashboard Community Number should be a positive integer")
        .integer("Metabase Dashboard Community Number should be an integer"),
      metabaseDashboardExperienceNumber: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired()
        .positive("Metabase Dashboard Experience Number should be a positive integer")
        .typeError("Metabase Dashboard Experience Number should be a positive integer")
        .integer("Metabase Dashboard Experience Number should be an integer"),
      metabaseDashboardLandlordRevenueNumber: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired()
        .positive("Metabase Dashboard Landlord Revenue Number should be a positive integer")
        .typeError("Metabase Dashboard Landlord Revenue Number should be a positive integer")
        .integer("Metabase Dashboard Landlord Revenue Number should be an integer"),
      metabaseDashboardLandlordFinanceNumber: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired()
        .positive("Metabase Dashboard Landlord Finance Number should be a positive integer")
        .typeError("Metabase Dashboard Landlord Finance Number should be a positive integer")
        .integer("Metabase Dashboard Landlord Finance Number should be an integer"),
      weekends: yup.array(),
      packageTier: yup.string(),
      paymentMethods: yup.string(),
      // .required("Payment method  is required")
      // .typeError("Payment method  is required"),
    })
    .required();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [checkedAmenities, setCheckedAmenities] = useState(location?.amenities);
  const handleCheckAmenities = (event) => {
    var updatedList = [...checkedAmenities];
    if (event.target.checked) {
      updatedList = [...checkedAmenities, event.target.value];
    } else {
      updatedList.splice(checkedAmenities.indexOf(event.target.value), 1);
    }
    setCheckedAmenities(updatedList);
  };

  const [mainImage, setMainImages] = useState([]);
  const [galleryImage, setGalleryImage] = useState([]);
  const [galleryImage2, setGalleryImage2] = useState([]);
  const [galleryImage3, setGalleryImage3] = useState([]);
  const [galleryImage4, setGalleryImage4] = useState([]);
  const [galleryImage5, setGalleryImage5] = useState([]);
  const [galleryCount, setGalleryCount] = useState(1);
  const [selectedLeader, setSelectedLeader] = useState([]);

  const handleAddGalleryImage = () => {
    setGalleryCount(galleryCount + 1);
  };

  useEffect(() => {
    setCheckedAmenities(location?.amenities?.map((a) => a._id));
    setMainImages(location?.mainImage ? [{ name: location?.mainImage, preview: location?.mainImage }] : []);
    setSelectedLeader({
      label: (
        <div
          key={`${location?.teamLeader?.phone}-${location?.teamLeader?.name}`}
          className="flex items-center"
        >
          {location?.teamLeader?.imageurl ? (
            <img
              src={location?.teamLeader?.imageurl}
              className="w-[35px] h-[35px] object-cover rounded-full mr-2"
              alt={location?.teamLeader?.name}
            />
          ) : (
            <div className="h-[35px] "></div>
          )}
          {location?.teamLeader?.name} / {location?.teamLeader?.phone}
        </div>
      ),
      value: location?.teamLeader?._id,
    });

    if (!facilityLoading) {
      setGalleryImage(
        location?.gallery.length > 0
          ? [
            {
              name: location?.gallery[0],
              preview: location?.gallery[0],
            },
          ]
          : []
      );
      setGalleryImage2(
        location?.gallery.length > 1
          ? [
            {
              name: location?.gallery[1],
              preview: location?.gallery[1],
            },
          ]
          : []
      );
      setGalleryImage3(
        location?.gallery.length > 2
          ? [
            {
              name: location?.gallery[2],
              preview: location?.gallery[2],
            },
          ]
          : []
      );
      // if (!location?.gallery[3] ) {
      setGalleryImage4(
        location?.gallery.length > 3
          ? [
            {
              name: location?.gallery[3],
              preview: location?.gallery[3],
            },
          ]
          : []
      );
      // }
      setGalleryImage5(
        location?.gallery.length > 4
          ? [
            {
              name: location?.gallery[4],
              preview: location?.gallery[4],
            },
          ]
          : []
      );
    }
  }, [facilityLoading]);

  const [submitLoading, setSubmitLoading] = useState(false);

  const isValidFile = (item) => {
    if (!item) return false;
    if (item instanceof File) {
      return item.size > 0 && item.type && item.type.startsWith('image/');
    }
    return false;
  };

  const uploadFile = async (file) => {
    if (!isValidFile(file)) {
      throw new Error("Invalid file provided");
    }
    const formData = new FormData();
    formData.append("image", file);
    const res = await http.post("/image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data?.url;
  };

  const onSubmit = async (passedData) => {
    setSubmitLoading(true);

    try {
      let mainImageUrl = location?.mainImage;
      
      if (mainImage.length > 0 && mainImage[0]) {
        const imageItem = mainImage[0];
        
        if (isValidFile(imageItem)) {
          try {
            mainImageUrl = await uploadFile(imageItem);
          } catch (error) {
            console.error("Failed to upload main image:", error);
            toast.error("Failed to upload main image. Using existing image.");
            mainImageUrl = location?.mainImage;
          }
        } else {
          mainImageUrl = imageItem?.preview || imageItem?.name || location?.mainImage;
        }
      }

      const galleryImages = [galleryImage, galleryImage2, galleryImage3, galleryImage4, galleryImage5];
      const galleryImagesUploaded = [];

      for (const gallery of galleryImages) {
        if (gallery.length > 0 && gallery[0]) {
          const imageItem = gallery[0];
          
          if (isValidFile(imageItem)) {
            try {
              const uploadedUrl = await uploadFile(imageItem);
              if (uploadedUrl) {
                galleryImagesUploaded.push(uploadedUrl);
              }
            } catch (error) {
              console.error("Failed to upload gallery image:", error);
            }
          } else {
            const existingUrl = imageItem?.preview || imageItem?.name;
            if (existingUrl) {
              galleryImagesUploaded.push(existingUrl);
            }
          }
        }
      }

      let filteredUploadGallery = galleryImagesUploaded.filter((g) => g !== undefined && g !== null);

      //TODO: now start and end hours are static values change them to be dynamic
      passedData.starts = "Mon, 10 Mar 2025 08:00:00 GMT";
      passedData.ends = "Mon, 10 Feb 2025 00:00:00 GMT";
      var data2 = JSON.stringify({
        name: passedData.name,
        area: passedData.area,
        netArea: passedData.netArea,
        amenities: checkedAmenities,
        mainImage: mainImageUrl,
        gallery: filteredUploadGallery,
        checkinPriceCoins: passedData.checkinPriceCoins,
        checkinPriceCash: passedData.checkinPriceCash,
        target: passedData.target,
        teamLeader: passedData.teamLeader,
        packageTier: passedData.packageTier,
        weekendDays: passedData.weekends,
        workingHours: {
          start: passedData.starts,
          end: passedData.ends,
        },
        notes: passedData.notes,
        nas: passedData.nas,
        metabaseDashboard: {
          REVENUE: passedData.metabaseDashboardRevenueNumber,
          FINANCE: passedData.metabaseDashboardFinanceNumber,
          COMMUNITY: passedData.metabaseDashboardCommunityNumber,
          EXPERIENCE: passedData.metabaseDashboardExperienceNumber,
          LANDLORD_REVENUE: passedData.metabaseDashboardLandlordRevenueNumber,
          LANDLORD_FINANCE: passedData.metabaseDashboardLandlordFinanceNumber,
        },
      });
      
      await http.put(`/location/${params.id}`, data2, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const newPaymentMethods = paymentMethods?.filter((p) => p.value).map((p) => p.value);
      if (newPaymentMethods.length > 0) {
        try {
          const locationId = location?._id || params.id;
          for (const name of newPaymentMethods) {
            await http.post(`/location/${locationId}/payment-methods`, { name });
          }
          refetchPaymentMethods();
        } catch (paymentError) {
          console.warn("Failed to update payment methods:", paymentError);
          const paymentErrorData = paymentError?.response?.data;
          toast.error(
            paymentErrorData?.message || "Failed to add one or more payment methods"
          );
        }
      }
      
      setSubmitLoading(false);
      facilityFetchData();
      setPaymentMethods([{ id: 1, value: "" }]);
      toast.success("Location has been edited successfully");
    } catch (error) {
      console.error("Error updating location:", error);
      
      let errorMessage = "Failed to update location";
      
      if (error?.response) {
        const status = error.response.status;
        const data = error.response.data;
        
        if (status === 307) {
          errorMessage = "Redirect error. Please try again.";
        } else if (status === 429) {
          errorMessage = data?.message || "Too many requests. Please try again later.";
        } else if (status === 401 || status === 403) {
          errorMessage = data?.message || "Authentication failed. Please refresh the page and try again.";
        } else if (data?.message) {
          errorMessage = data.message;
        } else if (data?.error) {
          errorMessage = typeof data.error === 'string' ? data.error : data.error.message || errorMessage;
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
      setSubmitLoading(false);
    }
  };

  const loadOptions = async (inputText, callback) => {
    let res = null;
    if (inputText.length > 0) {
      var data = JSON.stringify({
        textField: inputText,
        page: 1,
        limit: 10000,
      });
      let response = await http.post(`/admin`, data);
      res = response.data.data.data;
      callback(
        res.map((i) => ({
          label: (
            <div key={`${i.phone}-${i?.name}`} className="flex items-center">
              {i?.imageurl ? (
                <img
                  src={i?.imageurl}
                  className="w-[35px] h-[35px] object-cover rounded-full mr-2"
                  alt={i.name}
                />
              ) : (
                <div className="h-[35px] "></div>
              )}
              {i.name} / {i.phone}
            </div>
          ),
          value: i._id,
        }))
      );
    }
  };

  //payment methods
  const [paymentMethods, setPaymentMethods] = useState([{ id: 1, value: "" }]);
  const addPaymentMethod = () => {
    const newId = paymentMethods.length + 1;
    const newPaymentMethod = { id: newId, value: "" };
    setPaymentMethods([...paymentMethods, newPaymentMethod]);
  };
  const handlePaymentMethodChange = (index, value) => {
    const updatedMethods = [...paymentMethods];
    updatedMethods[index].value = value;
    setPaymentMethods(updatedMethods);
  };

  const removePaymentMethod = (index) => {
    const updatedMethods = paymentMethods.filter((_, i) => i !== index);
    setPaymentMethods(updatedMethods);
  };

  const handleDeletePaymentMethod = async (id) => {
    try {
      const locationId = location?._id || params.id;
      await http.delete(`/location/${locationId}/payment-methods/${id}`);
      refetchPaymentMethods();
      toast.success("Payment method deleted successfully");
    } catch (error) {
      const message = error?.response?.data?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const CustomNoOptionsMessage = ({ inputValue, onResetClick }) => (
    <div className="p-2">
      No results found{" "}
      <button
        className=" text-[18px]  text-[#34B2C0]  hover:opacity-95"
        style={{ fontFamily: "gilroy-bold" }}
        onClick={() => navigator(`/community/clients/new-client`)}
      >
        Add new client
      </button>
    </div>
  );

  return (
    <Layout>
      {!loading && !facilityLoading && !loadingPackageTiers ? (
        <div className="flex justify-center">
          <div className=" w-[75%]  bg-white p-4 m-1">
            <div className="flex flex-col">
              <div className="w-full flex justify-between">
                <span className=" text-[22px] font-bold my-2">Edit Location</span>
              </div>
              <span className="text-[16px]">Upload Images</span>
              <span className="text-[16px]">Supported formats: JPEG, PNG</span>
            </div>
            <div className="flex gap-[15px] ">
              <div className="w-full min-w-[60%] h-[315px] py-2">
                <div className="font-semibold my-1 text-[16px]">Upload Main image</div>
                <DropFile
                  image={mainImage}
                  setImage={setMainImages}
                  height={"315px"}
                  width={"600px"}
                />
              </div>

              {/* Gallery */}
              <div className="  w-full py-2  overflow-auto ">
                <div className="font-semibold my-1 text-[16px]">Upload Gallery images</div>
                <div className="w-fit gap-[15px] grid  grid-rows-2  grid-flow-col   ">
                  <DropFile
                    image={galleryImage}
                    setImage={setGalleryImage}
                    height={"150px"}
                    width={"275px"}
                  />

                  {galleryImage.length > 0 ? (
                    <DropFile
                      image={galleryImage2}
                      setImage={setGalleryImage2}
                      height={"150px"}
                      width={"275px"}
                    />
                  ) : (
                    <></>
                  )}

                  {galleryImage2.length > 0 ? (
                    <DropFile
                      image={galleryImage3}
                      setImage={setGalleryImage3}
                      height={"150px"}
                      width={"275px"}
                    />
                  ) : (
                    <></>
                  )}

                  {galleryImage3.length > 0 ? (
                    <DropFile
                      image={galleryImage4}
                      setImage={setGalleryImage4}
                      height={"150px"}
                      width={"275px"}
                    />
                  ) : (
                    <></>
                  )}

                  {galleryImage4.length > 0 ? (
                    <DropFile
                      image={galleryImage5}
                      setImage={setGalleryImage5}
                      height={"150px"}
                      width={"275px"}
                    />
                  ) : (
                    <></>
                  )}

                  {galleryImage4.length > 0 ? (
                    <></>
                  ) : (
                    <button
                      style={{ backgroundColor: "rgba(50, 179, 190, 0.1)" }}
                      onClick={() => handleAddGalleryImage}
                      className=" h-[150px] w-[275px]   flex flex-col  items-center justify-center  p-4 rounded-[5px]   border-[1px] border-[#32B3BE] border-dashed "
                    >
                      <img className="w-[45px] h-[45px]" src={plus} alt="plus" />
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* form  */}
            <form className="w-full " onSubmit={handleSubmit(onSubmit)}>
              <div className="mt-6">
                <TextInput
                  label={"Name*"}
                  defaultValue={location?.name}
                  {...register("name", { required: "input name is required" })}
                />

                <p className="text-red-500 text-[16px]">{errors.name?.message}</p>
              </div>

              <div className="mt-4">
                <div className=" flex flex-wrap gap-[5px] relative w-full h-fit py-3 bg-white border-[1px] border-[#EFEFEF] rounded-[5px] hover:border-[black] ">
                  <div className="absolute bg-white p-1 -top-4 text-[16px] left-2 text-[#00000099] ">
                    Amenities
                  </div>
                  {amenities?.data
                    ?.filter((a) => !a.isDeleted)
                    ?.map((item, index) => (
                      <div key={index} className=" ml-4">
                        <input
                          checked={checkedAmenities?.includes(item._id) ? true : false}
                          id={`cb${item._id}`}
                          className="hidden  peer "
                          value={item._id}
                          type="checkbox"
                          onChange={handleCheckAmenities}
                        />
                        <label
                          className={`  cursor-pointer hover:bg-[#32B3BE] hover:text-[white] transition-all peer-checked:bg-[#32B3BE] 
                        peer-checked:text-[white] peer-checked:font-semibold   text-[#32B3BE] border-[1px] flex  
                        justify-center items-center py-1 px-2 text-[16px] border-[#32B3BE] rounded-full min-w-[80px]  
                     `}
                          htmlFor={`cb${item._id}`}
                        >
                          {item.name}
                        </label>
                      </div>
                    ))}
                </div>
              </div>

              <hr className="my-4" />
              <div className="mt-4 mb-2 text-[20px] font-bold">Area</div>
              <div className="flex gap-4 w-full">
                <div className="w-1/2">
                  <CustomTextInput
                    label={"Area*"}
                    defaultValue={location?.area}
                    adornment={
                      <>
                        m<sup>2</sup>
                      </>
                    }
                    {...register("area", { required: "Area is required" })}
                  />
                  <p className="text-red-500 text-[16px]">{errors.area?.message}</p>
                </div>
                <div className="w-1/2">
                  <CustomTextInput
                    label={"Net Area*"}
                    defaultValue={location?.netArea}
                    adornment={
                      <>
                        m<sup>2</sup>
                      </>
                    }
                    {...register("netArea", {
                      required: "Net Area is required",
                    })}
                  />
                  <p className="text-red-500 text-[16px]">{errors.netArea?.message}</p>
                </div>
              </div>

              <hr className="my-4" />
              <div className="mt-4 flex w-full mb-2 text-[20px] font-bold">Check in price</div>
              <div className="flex w-full gap-4">
                <div className=" w-1/2  ">
                  <CustomTextInput
                    label={"Check in price coins*"}
                    defaultValue={location?.checkinPriceCoins}
                    adornment={
                      <>
                        <img className="w-[40px]" src={coin} alt="coin" />
                      </>
                    }
                    {...register("checkinPriceCoins", {
                      required: "Check in price coins is required",
                    })}
                  />
                  <p className="text-red-500 text-[16px]">{errors.checkinPriceCoins?.message}</p>
                </div>

                <div className="w-1/2">
                  <CustomTextInput
                    label={"Check in price cash*"}
                    adornment={<>EGP</>}
                    defaultValue={location?.checkinPriceCash}
                    {...register("checkinPriceCash", {
                      required: "Check in price cash is required",
                    })}
                  />
                  <p className="text-red-500 text-[16px]">{errors.checkinPriceCash?.message}</p>
                </div>
              </div>

              <hr className="my-4" />
              {/*
 <div className="mt-4 flex w-full mb-2  text-[20px] font-bold">Working hours</div>
              <div className="w-full flex mt-4  gap-4 ">
                <LocalizationProvider className="w-1/2" dateAdapter={AdapterDayjs}>
                  <Controller
                    control={control}
                    name="starts"
                    defaultValue={location?.workingHours?.start}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { invalid, isTouched, isDirty, error },
                    }) => (
                      <TimePicker
                        label="Working hours*"
                        value={value}
                        onBlur={onBlur} // notify when input is touched
                        onChange={onChange}
                        inputRef={ref}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <>Starts</>
                            </InputAdornment>
                          ),
                        }}
                        renderInput={(params) => (
                          <CustomTextField
                            style={{ width: "100%" }}
                            className="bg-white w-full"
                            {...params}
                          />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>

                <LocalizationProvider className="w-1/2" dateAdapter={AdapterDayjs}>
                  <Controller
                    control={control}
                    name="ends"
                    defaultValue={location?.workingHours?.end}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { invalid, isTouched, isDirty, error },
                    }) => (
                      <TimePicker
                        label="Working hours*"
                        value={value}
                        onBlur={onBlur} // notify when input is touched
                        onChange={onChange}
                        inputRef={ref}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <>Ends</>
                            </InputAdornment>
                          ),
                        }}
                        renderInput={(params) => (
                          <CustomTextField
                            style={{ width: "100%" }}
                            className="bg-white w-full"
                            {...params}
                          />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

                */}
             

              <div className="my-6">
                <div>
                  <FormControl fullWidth sx={{ border: "none !important" }}>
                    <InputLabel>Select Weekends</InputLabel>
                    <Controller
                      control={control}
                      name="weekends"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                      }) => (
                        <Select
                          sx={{
                            color: "black",
                            ".MuiOutlinedInput-notchedOutline": {
                              borderColor: "#EFEFEF",
                            },
                          }}
                          labelId="Select Weekends"
                          id="Select Weekends"
                          multiple
                          value={value ? value : location?.weekendDays?.map((w) => w)}
                          onBlur={onBlur} // notify when input is touched
                          onChange={onChange} // send value to hook form
                          input={<OutlinedInput label="Select Weekends" />}
                          MenuProps={MenuProps}
                          inputRef={ref}
                          defaultValue={[]}
                        >
                          {weekdays.map((w) => (
                            <MenuItem key={w.value} value={w.value}>
                              {w.name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                  <p className="text-red-500 text-[16px]">{errors.weekends?.message}</p>
                </div>
              </div>
              <hr className="my-4" />
              <div className="mt-4">
                <div className="mt-4 flex w-full mb-2 text-[20px] font-bold">Location Leader</div>
                <Controller
                  control={control}
                  name="teamLeader"
                  render={({ field }) => (
                    <AsyncSelect
                      components={{
                        NoOptionsMessage: ({ inputValue }) => (
                          <CustomNoOptionsMessage inputValue={inputValue} onResetClick={() => { }} />
                        ),
                      }}
                      {...field}
                      isClearable
                      defaultOptions
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          height: "56px",
                          borderRadius: "8px",
                          borderColor: "black",
                          "&:hover": {},
                        }),
                        option: (styles) => ({
                          ...styles,
                          zIndex: "999 !important",
                          backgroundColor: "white !important",
                        }),
                      }}
                      value={selectedLeader}
                      onChange={(value) => {
                        setSelectedLeader(value);
                        setValue("teamLeader", value.value);
                      }}
                      placeholder={"Search for Location Leader "}
                      loadOptions={loadOptions}
                    />
                  )}
                />
                <p className="text-red-500 text-[16px]">{errors.leader?.message}</p>
              </div>

              <hr className="my-4 w-full" />

              <div className="mt-4">
                <span className="text-[20px] font-bold">Payment Methods</span>
                <div className="flex flex-col ">
                  {(locationPaymentMethods || [])
                    ?.filter((p) => p?.status === "active")
                    ?.map((p) => (
                      <div
                        className="p-2 my-1 flex w-full justify-between items-center border-[1px] rounded-[10px] "
                        key={p?._id}
                      >
                        {p?.name}
                        <img
                          onClick={() => handleDeletePaymentMethod(p._id)}
                          src={stopIcon}
                          className="w-[30px] h-[30px] object-contain cursor-pointer"
                          alt="deleted"
                        />
                      </div>
                    ))}
                </div>

                <div className="mt-2">
                  <div className="text-[20px] font-bold">Add New payment methods</div>
                  <CustomTextInput
                    {...register("paymentMethods", {
                      required: "Payment methods name is required",
                    })}
                    label="Payment Method 1"
                    value={paymentMethods[0].value}
                    onChange={(e) => {
                      handlePaymentMethodChange(0, e.target.value);
                      setValue("paymentMethod", e.target.value);
                    }}
                  />

                  <p className="text-red-500 text-[16px]">{errors?.paymentMethods?.message}</p>
                </div>
                {paymentMethods.slice(1).map((method, index) => (
                  <div key={method.id} className="mt-2 flex items-center">
                    <CustomTextInput
                      label={`Payment Method ${index + 2}`}
                      value={method.value}
                      onChange={(e) => handlePaymentMethodChange(index + 1, e.target.value)}
                    />
                    <div onClick={() => removePaymentMethod(index + 1)} className="mx-2">
                      <img
                        src={stopIcon}
                        className="w-[30px] h-[30px] object-contain cursor-pointer"
                        alt="deleted"
                      />
                    </div>
                  </div>
                ))}
                <Button onClick={addPaymentMethod} secondary={true} invert={true}>
                  Add More
                </Button>
              </div>
              <hr className="my-4 w-full" />
              <div className="mt-4 ">
                <InputLabel> Target</InputLabel>
                <TextInput {...register("target")} type="number" defaultValue={location.target || 0} />
                <p className="text-red-500 text-[16px]">{errors.target?.message}</p>
              </div>
              <hr className="my-4 w-full" />
              <div>
                <div className="text-[20px] mb-2 font-bold">Package Tier</div>

                <FormControl fullWidth sx={{ border: "none !important" }}>
                  <InputLabel> Select package tier</InputLabel>
                  <Controller
                    control={control}
                    name={`packageTier`}
                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                      <Select
                        sx={{
                          color: "black",
                          backgroundColor: "white",
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "#EFEFEF",
                          },
                        }}
                        onBlur={onBlur} // notify when input is touched
                        onChange={onChange} // send value to hook form
                        variant="outlined"
                        labelId="Select package tier"
                        id=" Select package tier"
                        label=" Select package tier"
                        value={value}
                        inputRef={ref}
                        defaultValue={location?.packageTier}
                      >
                        {/* <MenuItem value={null}> None </MenuItem> */}

                        {packageTiers?.map((p) => (
                          <MenuItem key={p._id} value={p._id}>
                            {p.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>

                <p className="text-red-500 text-[14px] ">
                  {errors.packages && errors.packageTier?.message}
                </p>
              </div>
              <hr className="my-4 w-full" />

              <div className="mt-4 ">
                <TextInput label={"Notes"} defaultValue={location?.notes} {...register("notes")} />
                <p className="text-red-500 text-[16px]">{errors.notes?.message}</p>
              </div>
              <div className="mt-4 ">
                <TextInput label={"NAS"} defaultValue={location?.nas} {...register("nas")} />
                <p className="text-red-500 text-[16px]">{errors.nas?.message}</p>
              </div>
              <hr className="my-4" />
              <div className="mt-4 flex w-full mb-2 text-[20px] font-bold">Metabase Dashboard</div>
              <div className="flex w-full gap-4">
                <div className="mt-4 ">
                  <TextInput
                    label={"Revenue"}
                    defaultValue={location?.metabaseDashboard?.REVENUE}
                    {...register("metabaseDashboardRevenueNumber")}
                  />
                  <p className="text-red-500 text-[16px]">
                    {errors.metabaseDashboardRevenueNumber?.message}
                  </p>
                </div>

                <div className="mt-4 ">
                  <TextInput
                    label={"Finance"}
                    defaultValue={location?.metabaseDashboard?.FINANCE}
                    {...register("metabaseDashboardFinanceNumber")}
                  />
                  <p className="text-red-500 text-[16px]">
                    {errors.metabaseDashboardFinanceNumber?.message}
                  </p>
                </div>

                <div className="mt-4 ">
                  <TextInput
                    label={"Community"}
                    defaultValue={location?.metabaseDashboard?.COMMUNITY}
                    {...register("metabaseDashboardCommunityNumber")}
                  />
                  <p className="text-red-500 text-[16px]">
                    {errors.metabaseDashboardCommunityNumber?.message}
                  </p>
                </div>

                <div className="mt-4 ">
                  <TextInput
                    label={"Experience"}
                    defaultValue={location?.metabaseDashboard?.EXPERIENCE}
                    {...register("metabaseDashboardExperienceNumber")}
                  />
                  <p className="text-red-500 text-[16px]">
                    {errors.metabaseDashboardExperienceNumber?.message}
                  </p>
                </div>

                <div className="mt-4 ">
                  <TextInput
                    label={"Landlord Revenue"}
                    defaultValue={location?.metabaseDashboard?.LANDLORD_REVENUE}
                    {...register("metabaseDashboardLandlordRevenueNumber")}
                  />
                  <p className="text-red-500 text-[16px]">
                    {errors.metabaseDashboardLandlordRevenueNumber?.message}
                  </p>
                </div>

                <div className="mt-4 ">
                  <TextInput
                    label={"Landlord Finance"}
                    defaultValue={location?.metabaseDashboard?.LANDLORD_FINANCE}
                    {...register("metabaseDashboardLandlordFinanceNumber")}
                  />
                  <p className="text-red-500 text-[16px]">
                    {errors.metabaseDashboardLandlordFinanceNumber?.message}
                  </p>
                </div>
              </div>
              <div className="mt-4 mb-8 gap-10 flex justify-end">
                <Button onClick={() => navigator("/inventory")} secondary={true} invert={true}>
                  Cancel
                </Button>
                <Button loading={submitLoading} secondary={true} type="submit">
                  Edit
                </Button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <LoadingCircle />
      )}
    </Layout>
  );
};

export default EditLocation;
